module.exports = __webpack_public_path__ + "static/media/award_how@2x.f8c86366.png";